import { BaseService } from "./baseService";
class CrewService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "crew";
    }
}
export const crewService = new CrewService();
//# sourceMappingURL=crewService.js.map